import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Component() {
    const location = useLocation();

    const pathnames = location.pathname
        .split('/')
        .filter((x) => x);

    const capitalizeWords = (str) => {
        return str
            .replace(/-/g, ' ')
            .replace(/\b\w/g, (char) => char.toUpperCase());
    };

    return (
        <div className="policy-page-container">
            <div className="policy-breadcrumb">
                <div className="breadcrumb-content">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb-list">
                            <li className="breadcrumb-item">
                                <Link to="/">Home</Link>
                            </li>

                            {pathnames.map((value, index) => {
                                const to = `/${pathnames.slice(0, index + 1).join('/')}`;
                                const isLast = index === pathnames.length - 1;

                                return (
                                    <li
                                        key={to}
                                        className={`breadcrumb-item ${isLast ? 'active' : ''}`}
                                        aria-current={isLast ? 'page' : undefined}
                                    >
                                        {isLast ? (
                                            capitalizeWords(value)
                                        ) : (
                                            <Link to={to}>
                                                {capitalizeWords(value)}
                                            </Link>
                                        )}
                                    </li>
                                );
                            })}
                        </ol>
                    </nav>

                    <h1 className="breadcrumb-title">
                        {capitalizeWords(
                            pathnames[pathnames.length - 1] || 'home'
                        )}
                    </h1>
                </div>
            </div>
        </div>
    );
}
